"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var SideNav_1 = require("./SideNav");

var react_router_dom_1 = require("react-router-dom");

var history_1 = require("history");

var constants_1 = require("./constants");

exports.withRR4 = function () {
  var BaseSideNavWithRR4 =
  /** @class */
  function (_super) {
    __extends(BaseSideNavWithRR4, _super);

    function BaseSideNavWithRR4(props) {
      var _this = _super.call(this, props) || this;

      _this.state = {
        selectedPath: '',
        init: false
      };

      _this.onItemSelection = function (arg) {
        var location = _this.props.location;
        var payload = arg.payload;
        var withToPayload = payload;

        if (payload && withToPayload.to) {
          _this.props.history.push(history_1.createLocation(withToPayload.to, null, undefined, location));
        } else {
          var basePath = _this.props.basePath || '/';
          var path = arg.path.split(constants_1.PATH_SEPARATOR).join('/');

          _this.props.history.push(history_1.createLocation("" + basePath + path, null, undefined, location));
        }
      };

      return _this;
    }

    BaseSideNavWithRR4.prototype.componentDidMount = function () {
      var location = this.props.location;

      if (location && location.pathname) {
        var pathsArr_1 = location.pathname.split('/').filter(function (path) {
          return path;
        });
        var selectedPath = pathsArr_1.reduce(function (partial, path, index) {
          if (index + 1 === pathsArr_1.length) {
            return "" + partial + path;
          }

          return "" + partial + constants_1.PATH_SEPARATOR + path;
        }, "");
        this.setState({
          selectedPath: selectedPath,
          init: true
        });
      } else {
        this.setState({
          init: true
        });
      }
    };

    BaseSideNavWithRR4.prototype.componentDidUpdate = function (prevProps) {
      if (this.props.selectedPath !== prevProps.selectedPath) {
        this.setState({
          selectedPath: this.props.selectedPath || ''
        });
      }
    };

    BaseSideNavWithRR4.prototype.render = function () {
      if (!this.state.init) {
        return null;
      }

      var _a = this.props,
          defaultSelectedPath = _a.defaultSelectedPath,
          template = _a.template,
          theme = _a.theme;
      var selectedPath = this.state.selectedPath;
      var defaultSelection = selectedPath ? selectedPath : defaultSelectedPath;
      return React.createElement(SideNav_1.SideNav, {
        onItemSelection: this.onItemSelection,
        defaultSelectedPath: defaultSelection,
        template: template,
        theme: theme
      }, this.props.children);
    };

    return BaseSideNavWithRR4;
  }(React.Component);

  return react_router_dom_1.withRouter(BaseSideNavWithRR4);
};